app.factory('breakpointsService', function ($window, throttle, $rootScope) {
    var breakpoints = {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200
    };

    var calculateCurrentBreakpoint = function () {
        var previousBreakpoint = 'xs';
        var vw = $window.verge.viewportW();

        for (var breakpoint in breakpoints) {
            if (!breakpoints.hasOwnProperty(breakpoint)) continue;

            if (breakpoints[breakpoint] > vw) {
                break;
            } else {
                previousBreakpoint = breakpoint;
            }
        }

        return previousBreakpoint;
    };

    var currentBreakpoint = calculateCurrentBreakpoint();

    angular.element($window).on('resize', throttle(50, function () {
        $rootScope.$apply(function () {
            currentBreakpoint = calculateCurrentBreakpoint();
        });
    }));

    return {
        get current() {
            return currentBreakpoint;
        },
        compareBreakpoint: function (a, b) {
            var aw = breakpoints[a];
            var bw = breakpoints[b];

            if (typeof aw === 'undefined' || typeof bw === 'undefined')
                return NaN;

            if (aw > bw) {
                return 1;
            } else if (aw < bw) {
                return -1;
            }

            return 0;
        }
    };
});